// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__dMs22","text":"styles_text__ywfes","skeleton-animation":"styles_skeleton-animation__Lw8wr"};